import { SmartComply } from "./client/Smartcomply";
import { SmartComplyFlow } from "./flow/SmartComplyFlow";

export default SmartComply;
export { SmartComply, SmartComplyFlow };

// Config
export type { SDKConfig, Environment } from "./client/Config";

// Flow types
export type { FlowOptions, FlowResult } from "./flow/SmartComplyFlow";

// Onboarding types
export type {
  OnboardingType,
  VerifyIdentityRequest,
  VerifyIdentityResponse,
  SessionResponse,
  SDKInitConfig,
  SDKChannel,
} from "./types/onboarding";

// Liveness types
export type {
  ChallengeAction,
  LivenessCreateRequest,
  LivenessCreateResponse,
  LivenessSubmitResponse,
  LivenessWebhookPayload,
  LivenessResumeInfoResponse,
} from "./types/liveness";

// Response envelope types
export type {
  ApiResponse,
  FieldError,
  ErrorData,
} from "./types/common";

// Error classes
export { SDKError } from "./errors/SDKError";
export { AuthError } from "./errors/AuthError";
export { NetworkError } from "./errors/NetworkError";

// Utilities
export { SDKLogger } from "./utils/logger";
export { collectDeviceMetadata } from "./utils/device";
export type { DeviceMetadata } from "./utils/device";
export {
  isCameraSupported,
  queryCameraPermission,
  requestCameraAccess,
  releaseCameraStream,
} from "./camera/Permission";
export type { PermissionStatus, CameraPermissionResult } from "./camera/Permission";

// Liveness uploader (for integrators that need progress reporting)
export { LivenessUploader } from "./modules/liveness/uploader";
export type { UploadOptions } from "./modules/liveness/uploader";
